<div class="opcode-list-wrapper">
  <div class="opcode-panel">
    <div>
      <div class="header">
        <div class="title" [ngStyle]="{'padding-bottom' : onlineOpCodesCount > 0 ? '2rem' : ''}">{{ 'opcodeServiceManagement.opcodeServiceManagement' | translate }}</div>
        <div class="warning-msg" *ngIf="onlineOpCodesCount < 1 && !(onlineOpcodesLoading$ | async) ">
          <div><span class="material-icons" >info</span></div>
          <div>{{'navigation.pleaseMakeServiceOfferingsOnline' | translate }}</div>
        </div>
      </div>
      <div class='actions'>
      <div (click)="createNewOpcode()" class='action'><div class="box"><div class="plus">+</div></div>
      <div class="btnText">{{ 'opcodeServiceManagement.createService' | translate }}</div>
    </div>
  </div>
    <div class="panel-left" id="opCodesListSection">
      <form [formGroup]="opCodeListForm">
        <div formGroupName="allOpCodesForm" class="list-opcodes all-opcodes">
          <div class="list-title" [ngClass]="!isEnglishTranslation?'custom-padding':''">
            {{ 'opcodeServiceManagement.allOpcodes' | translate }} <span>({{(allOpCodesCount$ | async)}})</span>
            <div class="title-button" style="float: right;">
              <button (click)=updateFromDms() class='refresh' type="button"
                [title]="getIntegrationText()" 
                [disabled]="isDmsIntegrated ? (syncStatus$ | async) && (syncStatus$ | async)?.status === 'SYNC_IN_PROGRESS':true"
                [ngClass]="(syncStatus$ | async) && (syncStatus$ | async)?.status === 'SYNC_IN_PROGRESS' ? 'disabled': ''">
                <ng-container *ngIf="(syncStatus$ | async)?.status === 'SYNC_IN_PROGRESS'; else dmsSyncLabel">
                  <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".55" [compact]="true"></app-loading>
                </ng-container>
                <ng-template #dmsSyncLabel>
                  <asp-icon class="icon d-inline-block" name="ic-20-utility-update-small.svg" width="1.2rem"
                    height='1.2rem' color='var(--primary-toyota-color)'>
                  </asp-icon>
                  <span>{{'opcodeServiceManagement.updateFromDMS' | translate }}</span>
                </ng-template>
              </button>
            </div>
          </div>
          <div *ngIf="isDmsIntegrated" class="sync-text">
            <asp-icon class="icon d-inline-block" name="ic-20-utility-time-clock.svg" width="1.2rem" height='1.2rem'
              color='var(--primary-toyota-color)'>
            </asp-icon>
            <span>{{(syncStatus$ | async) && (syncStatus$ | async)?.lastSyncedAt ? (syncStatus$ | async)?.lastSyncedAt : '' }}</span>
          </div>
          <div class="list-opcode-container">
            <div class="search-form">
              <mat-form-field class="example-full-width" appearance="outline">
                <input type="text" formControlName="searchQuery" matInput placeholder="{{ 'opcodeServiceManagement.searchOpCode' | translate }}">
                <mat-icon matSuffix>search</mat-icon>
              </mat-form-field>
            </div>
            <div class="all-opcodes-sort-by d-flex" [ngClass]="'sort-' + sortOrder">
              <mat-form-field appearance="outline">
                <mat-label>{{ 'opcodeServiceManagement.show' | translate }}</mat-label>
                <mat-select formControlName="sortBy">
                  <mat-option value="alpha">{{ 'opcodeServiceManagement.alphabetically' | translate }}</mat-option>
                  <mat-option value="online">{{ 'opcodeServiceManagement.onlineCodes' | translate }}</mat-option>
                  <mat-option value="offline">{{ 'opcodeServiceManagement.offlineCodes' | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
              <asp-icon [title]="sortOrder + 'ending'" name="sort-asc-desc.svg" width="1.5rem" height="1.5rem"
                class="m-auto cursor-pointer" (click)=onSortOrderChange()></asp-icon>
            </div>
            <div id="all-opcodes" class="opcodes-list" [ngClass]="!isEnglishTranslation ? 'custom-height' : ''">

              <div *ngIf="(allOpcodesLoading$ | async) || isSortingAllOpcodes || isSearchLoading" class="d-flex opcode-list-skeleton"></div>

              <div *ngIf="(allOpCodesCount$ | async) > 0 && !isSearchLoading">
                <div *ngFor="let category of categories">

                  <mat-expansion-panel>

                    <mat-expansion-panel-header >
                      <mat-panel-title (click)="preventExpansion($event)">
                        <span class="category">{{ categoriesTranslation[category] | translate}} ({{(allOpCodes[category]?.length || 0)}})</span>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <multi-drag-drop class="d-flex"
                      emptyText="{{ 'otherTexts.thereAreNoServicesToDisplay' | translate }}"
                      [items]="allOpCodes[category]" [allowSort]="false"
                      [dragDisabled]="true"
                      (selectionChanged)="selectionChanged($event, 1, category)">
                      <ng-template let-item>
                        <app-opcode-item [item]="item" [index]="1"></app-opcode-item>
                      </ng-template>
                    </multi-drag-drop>
                  </mat-expansion-panel>
                </div>
              </div>
              <div *ngIf="(!(allOpcodesLoading$ | async)) && (allOpCodesCount$ | async) < 1">
                {{ 'otherTexts.thereAreNoServicesToDisplay' | translate}}
              </div>

            </div>
          </div>
        </div>
        <div class="arrow-container">
          <span [ngClass]="selectedOpcodeListFromOnline.length > 0  ? '' : 'hide-content'" class="selection-text mb-2">{{ (selectedOpcodeListFromOnline.length) + ('opcodeServiceManagement.selected' | translate)}}</span>
          <asp-icon class="indicator-height mb-2" name="move-left.svg" color="inherit" [ngClass]="selectedOpcodeListFromOnline.length > 0 ? 'highlight' : ''"
            (click)="updateServiceStatus(false)"></asp-icon>
          <asp-icon class="indicator-height inverse mb-2" name="move-left.svg" color="inherit"
            [ngClass]="selectedOpcodeListFromAll.length > 0  && isSelectedOpcodesValid(selectedOpcodeListFromAll) ? 'highlight' : 'no-update'" (click)="updateServiceStatus(true)">
          </asp-icon>
          <span [ngClass]="selectedOpcodeListFromAll.length > 0 ? '' : 'hide-content'"
            class="selection-text">{{ selectedOpcodeListFromAll.length + ('opcodeServiceManagement.selected' | translate)}}</span>
        </div>
        <div formGroupName="onlineOpCodesForm" class="list-opcodes online-opcodes">
          <div class="list-title">
            {{ 'opcodeServiceManagement.onlineOpcodes' | translate}} <span>({{(onlineOpCodesCount)}})</span>

            <span class="primary-text-color expand-collapse"
            (click)="isOnlineOpcodesExpandAll = !isOnlineOpcodesExpandAll">{{(isOnlineOpcodesExpandAll ?
            'checklist.collapseAll' : 'checklist.expandAll') | translate }}</span>

            <div class="title-button" style="float: right;" *ngIf="false">
              <button title="{{ 'opcodeServiceManagement.setupOpcodeToCaptureUnlistedServices' | translate}}" (click)=updateMiscOpCode() class='refresh' type="button"><span>{{ 'opcodeServiceManagement.setupMiscOpcode' | translate}}</span></button>
            </div>
          </div>
          <div class="list-opcode-container">
            <div class="all-opcodes-sort-by d-flex">
              <mat-form-field appearance="outline">
                <mat-label>{{'opcodeServiceManagement.show' | translate }}</mat-label>
                <mat-select formControlName="showOpCodes">
                  <mat-option value="all">{{'opcodeServiceManagement.all' | translate }}</mat-option>
                  <mat-option value="recommended">{{'opcodeServiceManagement.recommended' | translate }}</mat-option>
                  <mat-option value="setupNeeded">{{ 'opcodeServiceManagement.setupNeeded' | translate }}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            

            <div id="online-opcodes" class="online-opcodes-list online-list" [ngClass]="!isEnglishTranslation ? 'custom-height' : ''">

              <div *ngIf="(onlineOpcodesLoading$ | async)" class="d-flex opcode-list-skeleton"></div>

              <div *ngIf="onlineOpCodesCount > 0">
                <div *ngFor="let category of categories">

                  <mat-expansion-panel [expanded]="isOnlineOpcodesExpandAll">

                    <mat-expansion-panel-header>
                      <mat-panel-title class="d-block" (click)="preventExpansion($event)">
                        <div class="d-flex">
                        <span class="category">{{ categoriesTranslation[category] | translate}} ({{(onlineOpcodes[category]?.length || 0)}})</span>
                      </div>
                      <div>
                        <mat-form-field appearance="outline" class="mt-2">
                          <mat-label>{{ 'opcodeServiceManagement.onlineSorting' | translate }}</mat-label>
                          <mat-select [formControlName]="'sortBy' + category" (selectionChange)="onlineSortOrderChange($event, category)">
                            <mat-option value="alpha">{{ 'opcodeServiceManagement.alphabetical' | translate }}</mat-option>
                            <mat-option value="custom">{{ 'opcodeServiceManagement.custom' | translate }}</mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                      </mat-panel-title>
                    </mat-expansion-panel-header>

                    <multi-drag-drop class="d-flex"
                      emptyText="{{ 'otherTexts.thereAreNoServicesToDisplay' | translate }}"
                      [items]="onlineOpcodes[category]"
                      (itemsUpdated)="itemsUpdated($event, category)"
                      (selectionChanged)="selectionChanged($event, 2, category)">
                      <ng-template let-item>
                        <app-opcode-item [item]="item" [index]="2"></app-opcode-item>
                      </ng-template>
                    </multi-drag-drop>
                  </mat-expansion-panel>
                </div>
              </div>

              <div *ngIf="(!(onlineOpcodesLoading$ | async)) && onlineOpCodesCount < 1">
                {{ 'otherTexts.thereAreNoServicesToDisplay' | translate}}
              </div>

            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="panel-right">
      <app-opcode-service-form [opCode]="selectedOpcode" [isAllOpCodeList]="isAllOpCodeList"
      (formEdited)="formsEdited($event)" [saveClicked]="saveClicked">
      </app-opcode-service-form>
    </div>
  </div>

</div>
